// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-container {
  padding: 2rem 1rem;
  width: 100vw;
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  background: #f8f9fa;
  border-radius: 0;
  box-shadow: none;
}

.report-section {
  background-color: white;
  border-radius: 0;
  margin-bottom: 2rem;
  padding: 1.5rem;
  box-shadow: none;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

thead {
  background-color: #007bff;
  color: white;
  font-weight: 600;
}

th, td {
  padding: 0.6rem 0.8rem;
  border: 1px solid #ddd;
  text-align: left;
  vertical-align: middle;
}

tbody tr:nth-child(even) {
  background-color: #f2f6fc;
}

tbody tr:hover {
  background-color: #dbe9ff;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Reports.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".reports-container {\n  padding: 2rem 1rem;\n  width: 100vw;\n  margin: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #333;\n  background: #f8f9fa;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.report-section {\n  background-color: white;\n  border-radius: 0;\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  box-shadow: none;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\nthead {\n  background-color: #007bff;\n  color: white;\n  font-weight: 600;\n}\n\nth, td {\n  padding: 0.6rem 0.8rem;\n  border: 1px solid #ddd;\n  text-align: left;\n  vertical-align: middle;\n}\n\ntbody tr:nth-child(even) {\n  background-color: #f2f6fc;\n}\n\ntbody tr:hover {\n  background-color: #dbe9ff;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
